<div class="auth-main">
    <div *ngIf="loading" class="auth-main__loader">
        <loader type="page" message="Загружаем ..."></loader>
    </div>
    <ng-container [ngSwitch]="page">
        <div class="auth-main__content" *ngIf="!loading">
            <img
                class="auth-main__mobile-logo"
                src="./assets/icons/auth/brand-logo.svg"
                alt="Логотип"
            />
            <div class="auth-main__title">
                <img
                    src="./assets/icons/auth/back.svg"
                    (click)="goBack()"
                    alt=""
                />
                <span>{{ AuthFormTitle }}</span>
            </div>
            <p class="auth-main__subtitle">Регистрация пациента</p>
            <app-progress-bar [progress]="currentStep"></app-progress-bar>
            <ng-template ngSwitchCase="mainData">
                <form
                    (ngSubmit)="onSubmit1stepReg()"
                    [formGroup]="formRegistry"
                    class="form"
                    (keydown.enter)="focusNextInput($event)"
                >
                    <div class="form__field form__field--gender">
                        <input
                            type="radio"
                            id="sexMale"
                            formControlName="sex"
                            value="0"
                            class="form__radio-input"
                        />
                        <label
                            for="sexMale"
                            class="form__radio-btn"
                            [class.active]="
                                formRegistry.get('sex')?.value === '0'
                            "
                        >
                            Муж.
                        </label>
                        <input
                            type="radio"
                            id="sexFemale"
                            formControlName="sex"
                            value="1"
                            class="form__radio-input"
                        />
                        <label
                            for="sexFemale"
                            class="form__radio-btn"
                            [class.active]="
                                formRegistry.get('sex')?.value === '1'
                            "
                        >
                            Жен.
                        </label>
                    </div>
                    <label>
                        Фамилия
                        <span
                            *ngIf="isRequired(formRegistry, 'lastName')"
                            style="color: red"
                            >*</span
                        >
                    </label>
                    <div class="form__field">
                        <input
                            id="lastName"
                            type="text"
                            formControlName="lastName"
                            placeholder="Фамилия"
                            (input)="correctNameInput($event, 'lastName')"
                            #inputField
                            [ngClass]="{
                                'invalid-input':
                                    formRegistry.get('lastName')?.touched &&
                                    formRegistry.get('lastName')?.invalid,
                            }"
                        />
                    </div>
                    <label>
                        Имя
                        <span
                            *ngIf="isRequired(formRegistry, 'firstName')"
                            style="color: red"
                            >*</span
                        >
                    </label>
                    <div class="form__field">
                        <input
                            id="firstName"
                            type="text"
                            formControlName="firstName"
                            placeholder="Имя"
                            (input)="correctNameInput($event, 'firstName')"
                            #inputField
                            [ngClass]="{
                                'invalid-input':
                                    formRegistry.get('firstName')?.touched &&
                                    formRegistry.get('firstName')?.invalid,
                            }"
                        />
                    </div>
                    <ng-container
                        *ngIf="activeDocFields.includes('secondName')"
                    >
                        <label>
                            Отчество
                            <span
                                *ngIf="isRequired(formRegistry, 'secondName')"
                                style="color: red"
                                >*</span
                            >
                        </label>
                        <div class="form__field">
                            <input
                                id="secondName"
                                type="text"
                                formControlName="secondName"
                                placeholder="Отчество"
                                (input)="correctNameInput($event, 'secondName')"
                                #inputField
                                [ngClass]="{
                                    'invalid-input':
                                        formRegistry.get('secondName')
                                            ?.touched &&
                                        formRegistry.get('secondName')?.invalid,
                                }"
                            />
                        </div>
                    </ng-container>
                    <label>
                        Дата рождения
                        <span
                            *ngIf="isRequired(formRegistry, 'birthDate')"
                            style="color: red"
                            >*</span
                        >
                    </label>
                    <div class="form__field">
                        <input
                            id="birthDate"
                            [type]="dateInputType"
                            formControlName="birthDate"
                            placeholder="01.01.1999"
                            #inputField
                            [max]="maxBdate"
                            (focus)="onDateFocus()"
                            (blur)="onDateBlur()"
                            [ngClass]="{
                                'invalid-input':
                                    birthDateControl.invalid &&
                                    birthDateControl.touched,
                            }"
                        />
                    </div>
                    <div
                        *ngIf="
                            birthDateControl.invalid && birthDateControl.touched
                        "
                        class="warn-message"
                    >
                        <span *ngIf="birthDateControl.errors?.['required']">
                            Дата рождения обязательна
                        </span>
                        <span
                            *ngIf="
                                birthDateControl.errors?.['invalidDateFormat']
                            "
                            >Неверный формат даты (ДД.ММ.ГГГГ)</span
                        >
                        <span *ngIf="birthDateControl.errors?.['invalidDate']"
                            >Некорректная дата</span
                        >
                        <span *ngIf="birthDateControl.errors?.['futureDate']"
                            >Указанная дата еще не наступила</span
                        >
                        <span *ngIf="birthDateControl.errors?.['dateTooOld']"
                            >Дата слишком устаревшая</span
                        >
                    </div>

                    <button
                        mat-raised-button
                        type="submit"
                        [disabled]="formRegistry.invalid"
                        class="form__submit"
                    >
                        <ng-container>Далее</ng-container>
                        <ng-container>
                            <div class="form__submit-loader"></div>
                        </ng-container>
                    </button>
                </form>
            </ng-template>
            <ng-template ngSwitchCase="snilsPhoneMail">
                <form
                    (ngSubmit)="onSubmit2stepReg()"
                    [formGroup]="formSnilsPhoneMail"
                    class="form"
                    (keydown.enter)="focusNextInput($event)"
                >
                    <ng-container *ngIf="activeDocFields.includes('snils')">
                        <label>
                            СНИЛС
                            <span
                                *ngIf="isRequired(formSnilsPhoneMail, 'snils')"
                                style="color: red"
                                >*</span
                            >
                        </label>
                        <div class="form__field">
                            <input
                                id="snils"
                                type="text"
                                formControlName="snils"
                                placeholder="XXX-XXX-XXX XX"
                                snilsMask
                                [preValue]="formSnilsPhoneMail.value.snils"
                                maxlength="14"
                                #inputField
                                [ngClass]="{
                                    'invalid-input':
                                        formSnilsPhoneMail.get('snils')
                                            ?.touched &&
                                        formSnilsPhoneMail.get('snils')
                                            ?.invalid,
                                }"
                            />
                        </div>
                    </ng-container>
                    <ng-container *ngIf="activeDocFields.includes('inn')">
                        <label>
                            ИНН
                            <span
                                *ngIf="isRequired(formSnilsPhoneMail, 'inn')"
                                style="color: red"
                                >*</span
                            >
                        </label>
                        <div class="form__field">
                            <input
                                id="inn"
                                type="text"
                                formControlName="inn"
                                placeholder="XXXXXXXXXXXX"
                                maxlength="12"
                                (input)="removeSpaces($event)"
                                #inputField
                                [ngClass]="{
                                    'invalid-input':
                                        formSnilsPhoneMail.get('inn')
                                            ?.touched &&
                                        formSnilsPhoneMail.get('inn')?.invalid,
                                }"
                            />
                        </div>
                    </ng-container>
                    <ng-container *ngIf="activeDocFields.includes('phone')">
                        <label>
                            Номер телефона
                            <span
                                *ngIf="isRequired(formSnilsPhoneMail, 'phone')"
                                style="color: red"
                                >*</span
                            >
                        </label>
                        <div class="form__field">
                            <input
                                id="phone"
                                type="tel"
                                formControlName="phone"
                                phoneMask
                                #inputField
                                placeholder="+7 (___) ___-__-__"
                                [ngClass]="{
                                    'invalid-input':
                                        formSnilsPhoneMail.get('phone')
                                            ?.touched &&
                                        formSnilsPhoneMail.get('phone')
                                            ?.invalid,
                                }"
                            />
                        </div>
                    </ng-container>
                    <label>
                        E-mail
                        <span
                            *ngIf="isRequired(formSnilsPhoneMail, 'email')"
                            style="color: red"
                            >*</span
                        >
                    </label>
                    <div class="form__field">
                        <input
                            id="email"
                            type="email"
                            formControlName="email"
                            placeholder="user@mail.ru"
                            (input)="removeSpaces($event)"
                            (keydown.space)="$event.preventDefault()"
                            #inputField
                            [ngClass]="{
                                'invalid-input':
                                    formSnilsPhoneMail.get('email')?.touched &&
                                    formSnilsPhoneMail.get('email')?.invalid,
                            }"
                        />
                    </div>
                    <button
                        mat-raised-button
                        type="submit"
                        [disabled]="formSnilsPhoneMail.invalid"
                        class="form__submit"
                    >
                        <ng-container>Далее</ng-container>
                        <ng-container>
                            <div class="form__submit-loader"></div>
                        </ng-container>
                    </button>
                </form>
            </ng-template>
            <ng-template ngSwitchCase="agreement">
                <form
                    (ngSubmit)="onSubmit3stepReg()"
                    [formGroup]="formAgree"
                    class="form"
                    (keydown.enter)="focusNextInput($event)"
                >
                    <div class="captcha-block">
                        <div class="captcha-block__img">
                            <div
                                class="captcha__img"
                                [innerHTML]="captcha.svg | safe: 'html'"
                                *ngIf="!captchaLoad"
                            ></div>
                            <div *ngIf="captchaLoad" class="css-spinner"></div>

                            <button
                                class="captcha-block__refresh"
                                type="button"
                                (click)="refreshCaptcha()"
                            >
                                <mat-icon svgIcon="refresh"></mat-icon>
                            </button>
                        </div>
                        <div class="form__field">
                            <input
                                id="captcha"
                                type="string"
                                formControlName="captcha"
                                placeholder="Введите код с картинки"
                                maxlength="6"
                                (keydown.space)="$event.preventDefault()"
                                [ngClass]="{
                                    'invalid-input':
                                        formAgree.get('captcha')?.touched &&
                                        formAgree.get('captcha')?.invalid,
                                }"
                            />
                        </div>
                    </div>
                    @for (doc of agreementDocs; track doc.type) {
                        @if (doc.exist) {
                            <div class="form__field form__field--checkbox">
                                <input
                                    type="checkbox"
                                    [id]="doc.type"
                                    [formControlName]="doc.type"
                                    class="form__checkbox-input"
                                    [ngClass]="{
                                        'invalid-input':
                                            formAgree.get(doc.type)?.touched &&
                                            formAgree.get(doc.type)?.invalid,
                                    }"
                                />
                                <label 
                                    [for]="doc.type"
                                    class="form__checkbox-label"
                                >
                                    Согласен с 
                                    <a 
                                        [href]="doc.url"
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        class="form__checkbox-link"
                                    >
                                        {{doc.label}}
                                    </a>
                                </label>
                            </div>
                        }
                    }
                    <div class="error-message" *ngIf="errorMessage">
                        {{ errorMessage }}
                    </div>
                    <button
                        mat-raised-button
                        type="submit"
                        [disabled]="formAgree.invalid"
                        class="form__submit"
                    >
                        <ng-container>Далее</ng-container>
                        <ng-container>
                            <div class="form__submit-loader"></div>
                        </ng-container>
                    </button>
                </form>
            </ng-template>
            <div class="content-bottom">
                <div class="auth-main__register-hint">Есть аккаунт?</div>
                <div class="go-to-button" (click)="goToLogin()">Войти</div>
            </div>
        </div>
    </ng-container>
    <div class="auth-main__img" *ngIf="!loading">
        <img class="img-logo" src="./assets/icons/auth/brand-logo.svg" alt="" />
        <img
            class="img-doctor"
            src="./assets/icons/auth/registration-illustration.svg"
            alt=""
        />
    </div>
</div>